<template>
  <div class="barter-container">
    <div class="section-header">
      <div class="header-left">
        <h2 class="title">换货服务管理</h2>
        <span class="sub-title">采购订单换货申请进度跟踪与原厂换新物流协同</span>
      </div>
      <el-button type="primary" icon="el-icon-plus" class="btn-create" @click="handleToBarter()">
        新增换货申请
      </el-button>
    </div>

    <!-- 顶部状态胶囊导航 -->
    <div class="tab-capsule-wrapper">
      <div
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        class="tab-capsule"
        :class="{ active: form_head_uuid === item.form_head_uuid }"
        @click="changeIndex(item.form_head_uuid)"
      >
        <span>{{ item.name }}</span>
      </div>
    </div>

    <!-- 加载骨架屏 -->
    <div v-if="loading" class="order-skeleton-list">
      <div v-for="i in 3" :key="i" class="sk-order-card">
        <div class="sk-header">
          <div class="sk-bar w-30"></div>
          <div class="sk-bar w-20"></div>
        </div>
        <div class="sk-body">
          <div class="sk-img"></div>
          <div class="sk-details">
            <div class="sk-bar w-60"></div>
            <div class="sk-bar w-40"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 换货列表 -->
    <div class="orderBox" v-else-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span class="col-goods">换货商品信息</span>
        <span class="col-num">换货数量</span>
        <span class="col-status">当前进度</span>
      </div>

      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id" class="order-card-item">
          <div class="orderHeader">
            <div class="header-left">
              <span class="orderTime">
                <i class="el-icon-time"></i>
                {{ item.daivuh1o9jlphcxp }}
              </span>
              <span class="orderId">
                换货单编号：{{ item['3pp6dg9j4ex79ook'] }}
              </span>
            </div>
            <div class="header-right">
              <span class="status-badge" :class="getStatusBadgeClass(item.qpfsvknudb8gbzee)">
                {{ getStatusBadgeText(item.qpfsvknudb8gbzee) }}
              </span>
            </div>
          </div>

          <div
            class="orderDetail"
            v-for="(order, idx) in item.children"
            :key="idx"
          >
            <img
              :src="
                order.bal0wugwwskobosz && order.bal0wugwwskobosz.length > 0
                  ? order.bal0wugwwskobosz[0].url
                  : ''
              "
              alt="商品图片"
              class="goods-thumb"
            />
            <div class="goodsName">
              <p
                @click="navTo('/mall/goods/' + (order.tlztdbj3bxchs5vi && order.tlztdbj3bxchs5vi[0] ? order.tlztdbj3bxchs5vi[0].id : ''))"
                v-if="order.tlztdbj3bxchs5vi && order.tlztdbj3bxchs5vi.length > 0"
              >
                {{ order.tlztdbj3bxchs5vi[0].value }}
              </p>
            </div>
            <span class="num">{{ order['me6d75ufdtk3amaq'] || 0 }} 件</span>
            <span class="col-status-text">
              {{ getStatusBadgeText(item.qpfsvknudb8gbzee) }}
            </span>
          </div>

          <!-- 操作按钮栏 -->
          <div
            class="orderfooter"
            v-if="
              (item.qpfsvknudb8gbzee === 'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc' && item.indtkil4tvvff0ie === '4baade9e-2402-4ffd-9d57-74c1abc800cc' && item['3u7sabpxxpxioiqz']) ||
              (item.qpfsvknudb8gbzee === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4')
            "
          >
            <div class="footer-left"></div>
            <div class="footer-right">
              <el-button
                type="primary"
                size="small"
                v-if="
                  item.qpfsvknudb8gbzee === 'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc' &&
                  item.indtkil4tvvff0ie === '4baade9e-2402-4ffd-9d57-74c1abc800cc' &&
                  item['3u7sabpxxpxioiqz']
                "
                @click="confirmedMailReturn(item)"
              >
                确认邮寄退货
              </el-button>
              <el-button
                type="primary"
                size="small"
                v-if="item.qpfsvknudb8gbzee === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'"
                @click="resubmit(item)"
              >
                重新提交审核
              </el-button>
            </div>
          </div>
        </li>
      </ul>

      <!-- 分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 规范空状态 -->
    <div class="empty-gov-state" v-else>
      <div class="icon-circle">
        <i class="el-icon-sort"></i>
      </div>
      <p class="empty-title">暂无换货服务申请记录</p>
      <p class="empty-sub">若收到商品与采购计划存在规格差异，可点击右上角新增换货申请</p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { online, children, execButton } from "@/api/platform";
import { otherSystemGetLoginToMeUrl } from "@/util/util";

export default {
  name: "Barter",
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        { name: "全部", form_head_uuid: "01941b9eae0811ee879f0242321230b4" },
        { name: "审核中", form_head_uuid: "976291baa51a41559bfc6d41fa128aa2" },
        { name: "审核成功", form_head_uuid: "b9f9e6e04e524515b85a530b38b7c1e2" },
        { name: "审核失败", form_head_uuid: "5a7dfb24853a4408afc21d7b68e9f9fa" },
      ],
      form_head_uuid: "01941b9eae0811ee879f0242321230b4",
      orderList: [],
      loading: true,
      page: 1,
      total: 0,
      limit: 20,
    };
  },
  mounted () {
    this.getOrderList();
  },
  methods: {
    getStatusBadgeText (val) {
      if (val === 'ead617a0-f13a-49c6-b7d0-c18355f330c0') return '审核中';
      if (val === 'f5d63c14-f8ee-4279-81f8-4d63ae88df9c') return '审核成功';
      if (val === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4') return '审核失败';
      if (val === 'fa090b14-a3ee-4eac-89c2-32cfc12c5619') return '换货完成';
      if (val === 'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc') return '待寄回';
      return '处理中';
    },
    getStatusBadgeClass (val) {
      if (val === 'ead617a0-f13a-49c6-b7d0-c18355f330c0') return 'badge-reviewing';
      if (val === 'f5d63c14-f8ee-4279-81f8-4d63ae88df9c') return 'badge-approved';
      if (val === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4') return 'badge-rejected';
      if (val === 'fa090b14-a3ee-4eac-89c2-32cfc12c5619') return 'badge-finished';
      return 'badge-info';
    },
    // 获取订单列表
    async getOrderList () {
      this.loading = true;
      try {
        const { form_head_uuid, page, limit } = this;
        const { meta, result } = await online({
          form_head_uuid,
          page,
          limit,
          keyword: "",
          select_option: "",
        });
        if (Array.isArray(result)) {
          this.orderList = await Promise.all(
            result.map(async (el) => ({
              ...el,
              children: await this.children(el.id),
            }))
          );
        } else {
          this.orderList = [];
        }
        this.total = meta && meta.total ? meta.total : 0;
      } catch (e) {
        console.error("加载换货列表失败:", e);
        this.orderList = [];
      } finally {
        this.loading = false;
      }
    },
    // 获取子表数据
    async children (record_id) {
      try {
        const { form_head_uuid } = this;
        const { result } = await children({
          page: 1,
          limit: 100,
          field_uuid: "01942404ae0811ee8b7d0242321230b4",
          form_head_uuid,
          record_id,
        });
        return Array.isArray(result) ? result : [];
      } catch (e) {
        return [];
      }
    },
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      if (this.form_head_uuid === form_head_uuid) return;
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    navTo (route) {
      if (route) this.$router.push(route);
    },
    handleToBarter () {
      otherSystemGetLoginToMeUrl('90289196e59411ee8f230242ac150003', 'UvlkMQnzvibBsepj');
    },
    async confirmedMailReturn ({ id }) {
      try {
        await execButton({
          button_uuid: "4e515e73-30e2-4a5f-8d45-bf5b738200f6",
          form_head_uuid: "01941b9eae0811ee879f0242321230b4",
          id,
          type: 2,
        });
        this.$message.success("确认邮寄退货操作成功");
        this.page = 1;
        setTimeout(() => {
          this.getOrderList();
        }, 1500);
      } catch (e) {
        this.$message.error("操作失败，请稍后重试");
      }
    },
    resubmit ({ id }) {
      this.$confirm("确认要重新发起换货审核吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await execButton({
            button_uuid: "1b34a932-656e-4604-85dc-3614f20a2a42",
            form_head_uuid: "01941b9eae0811ee879f0242321230b4",
            id,
            type: 2,
          });
          this.$message.success("重新发起审核成功");
          this.page = 1;
          setTimeout(() => {
            this.getOrderList();
          }, 1500);
        })
        .catch(() => { });
    }
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.barter-container {
  width: 100%;

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #f1f5f9;

    .header-left {
      display: flex;
      align-items: baseline;
      gap: 12px;

      .title {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 0;
      }

      .sub-title {
        font-size: 13px;
        color: #64748b;
      }
    }

    .btn-create {
      background-color: @brandPrimary;
      border-color: @brandPrimary;
      font-weight: 600;
      padding: 9px 18px;
      border-radius: 6px;

      &:hover {
        background-color: @brandSecondary;
        border-color: @brandSecondary;
      }
    }
  }

  .tab-capsule-wrapper {
    display: flex;
    flex-wrap: wrap;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    margin-bottom: 20px;
    gap: 4px;

    .tab-capsule {
      padding: 6px 16px;
      font-size: 13px;
      font-weight: 500;
      color: #64748b;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;

      &:hover {
        color: @brandPrimary;
      }

      &.active {
        background: #ffffff;
        color: @brandPrimary;
        font-weight: 700;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      }
    }
  }

  /* 骨架屏 */
  .order-skeleton-list {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .sk-order-card {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 16px;
      background: #fff;

      .sk-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #f1f5f9;
      }

      .sk-body {
        display: flex;
        gap: 16px;

        .sk-img {
          width: 72px;
          height: 72px;
          border-radius: 6px;
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 200% 100%;
          animation: sk-shimmer 1.5s infinite;
        }

        .sk-details {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
      }

      .sk-bar {
        height: 16px;
        border-radius: 4px;
        background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
        background-size: 200% 100%;
        animation: sk-shimmer 1.5s infinite;

        &.w-20 { width: 20%; }
        &.w-30 { width: 30%; }
        &.w-40 { width: 40%; }
        &.w-60 { width: 60%; }
      }
    }
  }

  @keyframes sk-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* 表头 */
  .orderTableHeader {
    width: 100%;
    height: 42px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px 6px 0 0;
    color: #475569;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;

    span {
      text-align: center;

      &.col-goods {
        flex: 1;
        text-align: left;
        padding-left: 20px;
      }

      &.col-num { width: 140px; }
      &.col-status { width: 140px; }
    }
  }

  /* 列表 */
  .orderList {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;

    .order-card-item {
      border: 1px solid #e2e8f0;
      border-top: none;
      background: #ffffff;
      transition: all 0.2s ease;
      margin-bottom: 12px;
      border-radius: 0 0 6px 6px;

      &:hover {
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
      }

      .orderHeader {
        background-color: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        height: 44px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-left {
          display: flex;
          align-items: center;
          gap: 16px;

          .orderTime {
            font-size: 13px;
            font-weight: 600;
            color: #1e293b;
            display: flex;
            align-items: center;
            gap: 6px;

            i { color: @brandPrimary; }
          }

          .orderId {
            font-size: 12px;
            color: #64748b;
          }
        }

        .header-right {
          .status-badge {
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            font-weight: 600;

            &.badge-reviewing {
              background: #eff6ff;
              color: @brandPrimary;
              border: 1px solid #bfdbfe;
            }

            &.badge-approved {
              background: #ecfdf5;
              color: #10b981;
              border: 1px solid #a7f3d0;
            }

            &.badge-rejected {
              background: #fef2f2;
              color: #ef4444;
              border: 1px solid #fecaca;
            }

            &.badge-finished {
              background: #f8fafc;
              color: #475569;
              border: 1px solid #e2e8f0;
            }

            &.badge-info {
              background: #f1f5f9;
              color: #64748b;
            }
          }
        }
      }

      .orderDetail {
        display: flex;
        align-items: center;
        padding: 14px 16px;
        border-bottom: 1px dashed #f1f5f9;

        &:last-of-type {
          border-bottom: none;
        }

        .goods-thumb {
          width: 64px;
          height: 64px;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
          object-fit: cover;
          flex-shrink: 0;
        }

        .goodsName {
          flex: 1;
          padding: 0 16px;

          p {
            margin: 0;
            font-size: 13px;
            line-height: 1.5;
            color: #1e293b;
            font-weight: 500;
            cursor: pointer;

            &:hover {
              color: @brandPrimary;
            }
          }
        }

        .num, .col-status-text {
          width: 140px;
          text-align: center;
          font-size: 13px;
          flex-shrink: 0;
        }

        .num { color: #334155; font-weight: 500; }
        .col-status-text { color: #64748b; font-size: 12px; }
      }

      .orderfooter {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 16px;
        background: #ffffff;
        border-top: 1px solid #f1f5f9;
        gap: 10px;
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0;
  }

  /* 空状态 */
  .empty-gov-state {
    padding: 60px 0;
    text-align: center;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    margin-top: 16px;

    .icon-circle {
      width: 60px;
      height: 60px;
      margin: 0 auto 14px;
      border-radius: 50%;
      background: #eff6ff;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 28px;
        color: @brandPrimary;
      }
    }

    .empty-title {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      margin: 0 0 6px;
    }

    .empty-sub {
      font-size: 13px;
      color: #94a3b8;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/Barter.vue